import {
  storefrontAbTestIdFormat,
  storefrontTreatmentIdFormat,
} from "@redotech/redo-coverage-id";
import {
  StorefrontAbTestAndTreatmentsSchema,
  StorefrontAbTestSchema,
} from "@redotech/redo-storefront-ab-test-common/storefront-ab-test";
import { StorefrontTreatmentSettingsSchema } from "@redotech/redo-storefront-ab-test-common/storefront-treatment-settings";
import * as z from "zod";

const nameSchema = z.string().trim().min(1).max(200);

export const listStorefrontAbTests = {
  name: "listStorefrontAbTests" as const,
  input: z.object({}),
  output: z.object({ tests: z.array(StorefrontAbTestSchema) }),
};

export const createStorefrontAbTest = {
  name: "createStorefrontAbTest" as const,
  input: z.object({ name: nameSchema }),
  output: z.object({ test: StorefrontAbTestSchema }),
};

export const getStorefrontAbTest = {
  name: "getStorefrontAbTest" as const,
  input: z.object({ id: storefrontAbTestIdFormat.schema }),
  output: z.object({ abTest: StorefrontAbTestAndTreatmentsSchema }),
};

const treatmentFieldsSchema = z.object({
  name: nameSchema,
  weight: z.number().int().min(0).max(100),
  coverageEnabled: z.boolean(),
});

/**
 * Saves the test and its full arm list in display order. Arms left out are
 * deleted; arms without an id are created with their settings.
 */
export const updateStorefrontAbTest = {
  name: "updateStorefrontAbTest" as const,
  input: z.object({
    id: storefrontAbTestIdFormat.schema,
    name: nameSchema,
    treatments: z
      .array(
        z.union([
          treatmentFieldsSchema.extend({
            id: storefrontTreatmentIdFormat.schema,
          }),
          treatmentFieldsSchema.extend({
            id: z.null(),
            settings: StorefrontTreatmentSettingsSchema,
          }),
        ]),
      )
      .min(1),
  }),
  output: z.object({ abTest: StorefrontAbTestAndTreatmentsSchema }),
};

export const updateStorefrontTreatmentSettings = {
  name: "updateStorefrontTreatmentSettings" as const,
  input: z.object({
    id: storefrontTreatmentIdFormat.schema,
    settings: StorefrontTreatmentSettingsSchema,
  }),
  output: z.object({}),
};

/** Starts serving the test's arms on the storefront. */
export const startStorefrontAbTest = {
  name: "startStorefrontAbTest" as const,
  input: z.object({ id: storefrontAbTestIdFormat.schema }),
  output: z.object({ abTest: StorefrontAbTestAndTreatmentsSchema }),
};

/** Stops serving the test's arms; the storefront falls back to team settings. */
export const stopStorefrontAbTest = {
  name: "stopStorefrontAbTest" as const,
  input: z.object({ id: storefrontAbTestIdFormat.schema }),
  output: z.object({ abTest: StorefrontAbTestAndTreatmentsSchema }),
};
